import { GlobalAlert } from '@thoughtspot/global-alert';
import { useTranslation } from '@thoughtspot/i18n';
import { BannerAlertType } from '@thoughtspot/radiant-react/widgets/alert';
import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Vertical } from '../../../utils/layouts';
import styles from './common.module.scss';
export const WithQueryHandler = ({ children }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [upgradeInProgress, setUpgradeInProgress] = useState(false);
    const [banner, setBanner] = useState({
        visible: false,
        message: '',
        type: BannerAlertType.ERROR,
    });
    const [toast, setToast] = useState({
        visible: false,
        message: '',
    });
    const hideLoader = () => {
        setLoading(false);
        setUpgradeInProgress(false);
    };
    const primaryActionForToast = {
        label: t('admin.refresh'),
        onClick: () => {
            window.location.reload();
        },
    };
    const onSuccess = (message, showRefreshButton = false) => {
        hideLoader();
        setBanner({
            ...banner,
            visible: false,
            message: '',
        });
        if (message) {
            setToast({
                visible: true,
                message,
                showRefreshButton,
            });
        }
    };
    const onError = (error) => {
        hideLoader();
        setBanner({
            ...banner,
            visible: true,
            message: error,
        });
    };
    const showLoader = () => {
        setUpgradeInProgress(true);
        setLoading(true);
    };
    const blockUserUI = () => upgradeInProgress
        ? ReactDOM.createPortal(React.createElement("div", { className: styles.editScreenBlockUsage }), document.body)
        : null;
    return (React.createElement(React.Fragment, null,
        blockUserUI(),
        React.createElement(Vertical, { className: styles.container },
            React.createElement(GlobalAlert.Banner, { isVisible: banner.visible, message: banner.message, type: banner.type, onClose: () => setBanner({
                    ...banner,
                    visible: false,
                    message: '',
                }) }),
            React.createElement(GlobalAlert.Toast, { isVisible: toast.visible, message: toast.message, primaryAction: toast.showRefreshButton
                    ? primaryActionForToast
                    : undefined, onClose: () => setToast({
                    ...toast,
                    visible: false,
                    message: '',
                }), autoHide: true }),
            loading && (React.createElement(LoadingIndicator.Global, { hideLoader: !loading, className: styles.fullScreenLoader },
                React.createElement(React.Fragment, null))),
            children &&
                React.cloneElement(children, {
                    onSuccess,
                    onError,
                    showLoader,
                    hideLoader,
                }))));
};
//# sourceMappingURL=query-handler.js.map